import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9416efe0 = () => interopDefault(import('../src/pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _3ad77932 = () => interopDefault(import('../src/pages/calculators/index.vue' /* webpackChunkName: "pages/calculators/index" */))
const _6a45be49 = () => interopDefault(import('../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _2d3a8949 = () => interopDefault(import('../src/pages/terms-of-use.vue' /* webpackChunkName: "pages/terms-of-use" */))
const _6ecf3110 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _544026c2 = () => interopDefault(import('../src/pages/tables/_id.vue' /* webpackChunkName: "pages/tables/_id" */))
const _120b2fa8 = () => interopDefault(import('../src/pages/_name.vue' /* webpackChunkName: "pages/_name" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _9416efe0,
    caseSensitive: true,
    name: "about-us"
  }, {
    path: "/calculators",
    component: _3ad77932,
    caseSensitive: true,
    name: "calculators"
  }, {
    path: "/privacy-policy",
    component: _6a45be49,
    caseSensitive: true,
    name: "privacy-policy"
  }, {
    path: "/terms-of-use",
    component: _2d3a8949,
    caseSensitive: true,
    name: "terms-of-use"
  }, {
    path: "/",
    component: _6ecf3110,
    caseSensitive: true,
    name: "index"
  }, {
    path: "/tables/:id?",
    component: _544026c2,
    caseSensitive: true,
    name: "tables-id"
  }, {
    path: "/:name",
    component: _120b2fa8,
    caseSensitive: true,
    name: "name"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
